import { useMatches } from 'react-router-dom';

export const useMatchPathParams = () => {
  const matches = useMatches();

  return matches.at(-1)?.params ?? {};
};
